const path = 'https://api.ipify.org/?format=json'

export const getip = () => {

    let h = new Headers();
    h.append('Content-Type', 'application/json');
    let req = new Request(path, {
        method: 'GET',
        headers: h
    });

    return fetch(req);
}